import React from 'react';
import { Spinner } from 'react-bootstrap';

import AvailableProduct from './AvailableProduct';
import * as Ui from './AvailableProductsList.styles';

const AvailableProductsList = ({
  products,
  fetchNextAvailableProducts,
  addedProducts,
  onAdd,
  hasNextPage,
  isLoading,
  isLoadingNextPage,
}) => {
  if (isLoading) {
    return (
      <Ui.EmptyState>
        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
      </Ui.EmptyState>
    );
  }

  if (!products?.length) {
    return <Ui.EmptyState>No products found</Ui.EmptyState>;
  }

  return (
    <Ui.ScrollableWrapper id="scrollable-container">
      <Ui.ProductsWrapper
        scrollableTarget="scrollable-container"
        dataLength={products.length}
        next={() => {
          if (hasNextPage && !isLoadingNextPage) {
            fetchNextAvailableProducts();
          }
        }}
        hasMore={Boolean(hasNextPage)}
      >
        {products.map((product) => (
          <AvailableProduct
            key={product.uid}
            product={product}
            addedProducts={addedProducts}
            onAdd={onAdd}
          />
        ))}
      </Ui.ProductsWrapper>
      {isLoadingNextPage && (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: 16 }}>
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
        </div>
      )}
    </Ui.ScrollableWrapper>
  );
};

export default AvailableProductsList;
